// extracted by mini-css-extract-plugin
export const aside__illustration = "index-module--aside__illustration--13tBF";
export const aside__title = "index-module--aside__title--3fq8U";
export const aside__social__button = "index-module--aside__social__button--3EXxf";
export const postSection = "index-module--postSection--2TAaJ";
export const post = "index-module--post--35ElZ";